import React, { Component } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

import './Tickets.css';

class Tickets extends Component {
  render() {
    return (
      <div className="Tickets" ref={(div) => (this.appContainer = div)}>
        <Header />
        <div className="Tickets-container">
          <div className="Tickets-top"></div>
          <div className="Tickets-mid">
            <div className="Tickets-header">TICKETS & GIFT CARDS</div>
            <hr />
            <div className="Tickets-button">
              <a
                href="https://bookeo.com/thebunkerexperience"
                target="_blank"
                rel="noopener noreferrer"
              >
                PURCHASE TICKETS
              </a>
            </div>
            <div className="Tickets-button">
              <a
                href="https://bookeo.com/thebunkerexperience/buyvoucher"
                target="_blank"
                rel="noopener noreferrer"
              >
                PURCHASE GIFT CARDS
              </a>
            </div>
            <div className="Tickets-button">
              <a
                href="https://bookeo.com/thebunkerexperience/voucher"
                target="_blank"
                rel="noopener noreferrer"
              >
                REDEEM A GIFT CARD
              </a>
            </div>
            <div className="tickets-container"></div>
          </div>
          <div className="Tickets-bottom"></div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Tickets;
